<div
  bsModal
  #nodesEditorModal="bs-modal"
  [config]="{
    show: false,
    ignoreBackdropClick: hierarchyEditor?.isSaving,
    keyboard: hierarchyEditor && !hierarchyEditor.isSaving
  }"
  [rlTrapFocus]="focusTrapConfig"
  (onHidden)="onHide()"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="nodes-editor-modal"
  aria-hidden="true"
>
  <div class="modal-dialog qa-nodes-editor-modal-dialog">
    <div class="modal-content" *ngIf="isModalShown">
      <div class="modal-header">
        <h2
          class="modal-title"
          id="nodes-editor-modal"
          i18n="@@nodesEditorModal-heading-hierarchyAndStudentNumbers"
        >
          Hierarchy and student numbers
        </h2>
      </div>

      <rl-nodes-editor
        *ngIf="hierarchyEditor ? true : false"
        [isHierarchyUpdateEnabled]="isHierarchyUpdateEnabled"
        [hierarchyEditor]="hierarchyEditor"
        [permissions]="permissions"
        [isNewList]="isNewList"
        (close)="onHide()"
        (save)="onSave($event)"
      >
      </rl-nodes-editor>
    </div>
  </div>
</div>
